export default (props, vars) => props?.['variant'] === 'v2';
